export class SendEmailServiceConstants {
    // static readonly url = {
    //   postEmailUrl: "api/v2/Communication/GenerateEmail"
    // }
    static COMPONENT_NAME = "Send Email Service";
    static AD_HOC_COMMS = "AdHocComms";
}
